module.exports = __webpack_public_path__ + "img/logo.v0.1.2.1793842988418.png";